import ButtonLink from 'components/shared/ButtonLink.styled';
import styled from 'styled-components';
import { getPublicPath } from 'utils/paths';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from '../../../../theme';

export const StyledCta = styled.div`
  max-width: ${container('md')};
  margin: ${spacing('xl4')} auto;
  background-color: ${color('indigo_900')};
  border-radius: ${radius('lg')};
  padding-top: ${spacing('sm')};
  padding-bottom: ${spacing('xl3')};
  padding-left: ${spacing('xl8')};
  padding-right: ${spacing('xl4')};
  color: ${color('text_white')};
  background-image: ${() =>
    `url('${getPublicPath('/images/successStories/register-cta-bg.svg')}')`};
  background-size: cover;
  background-position: left 0;
  background-repeat: no-repeat;

  @media (max-width: ${screen('mdMax')}) {
    background-size: unset;
    background-position: left 5% bottom;
    padding-top: ${spacing('xl')};
    padding-bottom: ${spacing('xl3')};
    padding-left: 140px;
    padding-right: ${spacing('xl')};
  }

  ${ButtonLink} {
    margin-top: ${spacing('md')};

    @media (max-width: ${screen('mdMax')}) {
      padding: ${spacing('sm')};
      font-size: ${fontSize('xs')};
    }
  }
`;

export const StyledTitle = styled.p`
  font-size: ${fontSize('sm')};
  text-transform: uppercase;
  line-height: 1.2;
  font-weight: ${fontWeight('extraBold')};
  color: ${color('indigo_300')};
  margin-bottom: ${spacing('xs')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('sm')};
    text-transform: unset;
  }
`;
